<template>
  <el-col>
      <div class="C-UserCenterMenu">
        <router-link to="/usercenter" tag="div" class="MenuItem">
          <div class="Icon">
            <svg-icon icon-class="user"></svg-icon>
          </div>
          <div class="Title">会员中心</div>
        </router-link>
        <router-link to="/publish" tag="div" class="MenuItem">
          <div class="Icon">
            <svg-icon icon-class="publish"></svg-icon>
          </div>
          <div class="Title">信息发布</div>
        </router-link>
        <router-link to="/myinfo" tag="div" class="MenuItem">
          <div class="Icon">
            <svg-icon icon-class="info"></svg-icon>
          </div>
          <div class="Title">我的信息</div>
        </router-link>
        <router-link to="/myfavorite" tag="div" class="MenuItem">
          <div class="Icon">
            <svg-icon icon-class="noheart"></svg-icon>
          </div>
          <div class="Title">我的收藏</div>
        </router-link>
        <router-link to="/upgrade" tag="div" class="MenuItem">
        <div class="Icon">
          <svg-icon icon-class="vip"></svg-icon>
        </div>
        <div class="Title">升级vip</div>
      </router-link>
        <router-link to="/editprofile" tag="div" class="MenuItem">
          <div class="Icon">
            <svg-icon icon-class="user-management"></svg-icon>
          </div>
          <div class="Title">修改资料</div>
        </router-link>
        <router-link to="/proxy" tag="div" class="MenuItem" v-if="$store.getters.proxy">
          <div class="Icon">
            <svg-icon icon-class="proxy"></svg-icon>
          </div>
          <div class="Title">代理合作</div>
        </router-link>
        <router-link to="/promote" tag="div" class="MenuItem" v-if="$store.getters.promote">
          <div class="Icon">
            <svg-icon icon-class="proxy"></svg-icon>
          </div>
          <div class="Title">推广</div>
        </router-link>
        <div class="MenuItem" @click="dialogVisible = true">
          <div class="Icon">
            <svg-icon icon-class="exit"></svg-icon>
          </div>
          <div class="Title">登出</div>
        </div>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          :lock-scroll = false
          :show-close = false>
          <span style="font-size: 16px">确定登出？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="out(), dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
      </div>
  </el-col>
</template>

<script>
import axios from 'axios'

export default {
  name: 'usernav',
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    out () {
      axios({
        url: '/api/out',
        methods: 'get'
      }).then(function (res) {
        if (res.data['status'] === 0) {
          localStorage.removeItem('promote')
          this.$store.commit('promote', localStorage.getItem('promote'))
          localStorage.removeItem('Flag')
          this.$store.commit('Flag', localStorage.getItem('Flag'))
          localStorage.removeItem('proxy')
          this.$store.commit('proxy', localStorage.getItem('proxy'))
          this.$message.success({
            message: '成功退出'
          })
          location.reload()
        }
      }.bind(this))
    }
  }
}
</script>

<style scoped>
  .C-UserCenterMenu {
    display: none !important;
    background-color: #fff !important;
    color: #666;
  }
  @media (min-width: 768px) {
    .C-UserCenterMenu {
      display: flex !important;
    }
  }

  .MenuItem {
    cursor: pointer;
    border-right: 1px solid #f2f2f2 !important;
    width: 80px;
    padding: 5px;
  }
  .Icon {
    flex: 0 0 100%;
    max-width: 100%;
    padding-top: 10px;
    position: relative;
    width: 100%;
  }

  .svg-icon {
    width: 1.6em;
    height: 1.6em;
    vertical-align: -0.15em;
    fill: currentColor;
  }

  .Title {
    padding-top: 10px;
    font-size: 14px;
    padding-bottom: 10px;
  }
  .active{
    color: #fff;
    background: #f39;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/header/usernav.vue